(function (appSetup) {
	// clean the file, call each plugin update on demand, write a fn like callPlugin("iCheck", "select2")
	appSetup.$Scripts = {
		all: function () {
			var scripts = this;
			for (var script in scripts) {
				if (script == "all" || script == "base") {} else {
					try {
						scripts[script]();
					} catch (e) {
						console.log(e);
					}
				}
			}
		},
		// called on demand
		base: {
			select2: function () {
				$("select").select2({
					minimumResultsForSearch: 7,
					placeholder: function () {
						$(this).data('placeholder');
					}
				});
			},
			iCheck: function () {
				$('input[type="checkbox"], input[type="radio"]').iCheck({
					checkboxClass: 'icheckbox_square-blue',
					radioClass: 'iradio_square-blue',
					increaseArea: '20%' // optional
				});
			},
			accWizard: function () {
				$(".acc-wizard").accwizard();
			},
			owl: function () {

				$('.product-carousel').owlCarousel({
					responsive: true,
					itemsCustom: [
						[0, 1],
						[768, 2],
						[1024, 3],
						[1200, 4]
					]
				});

				var sync1 = $("#sync1");
				var sync2 = $("#sync2");
				sync1.owlCarousel({
					singleItem: true,
					slideSpeed: 1000,
					navigation: false,
					pagination: false,
					afterAction: syncPosition,
					responsiveRefreshRate: 200
				});
				sync2.owlCarousel({
					items: 3,
					itemsCustom: [
						[1200, 3]
					],
					pagination: false,
					responsiveRefreshRate: 100,
					afterInit: function (el) {
						el.find(".owl-item").eq(0).addClass("synced");
					}
				});

				function syncPosition(el) {
					var current = this.currentItem;
					$("#sync2")
						.find(".owl-item")
						.removeClass("synced")
						.eq(current)
						.addClass("synced");
					if ($("#sync2").data("owlCarousel") !== undefined) {
						center(current);
					}
				}

				$("#sync2").on("click", ".owl-item", function (e) {
					e.preventDefault();
					var number = $(this).data("owlItem");
					sync1.trigger("owl.goTo", number);
				});

				function center(number) {
					var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
					var num = number;
					var found = false;
					for (var i in sync2visible) {
						if (num === sync2visible[i]) {
							found = true;
						}
					}

					if (found === false) {
						if (num > sync2visible[sync2visible.length - 1]) {
							sync2.trigger("owl.goTo", num - sync2visible.length + 2);
						} else {
							if (num - 1 === -1) {
								num = 0;
							}
							sync2.trigger("owl.goTo", num);
						}
					} else if (num === sync2visible[sync2visible.length - 1]) {
						sync2.trigger("owl.goTo", sync2visible[1]);
					} else if (num === sync2visible[0]) {
						sync2.trigger("owl.goTo", num - 1);
					}

				}
			}

		},
		accordionSigns: function () {
			var selectIds = $('#inner-collapseOne,#inner-collapseTwo,#inner-collapseThree,#inner-collapseFour,#inner-collapseFive,#inner-collapseOne-b,#inner-collapseOne-c,#inner-collapseOne-d, #aside-inner-collapseOne, #aside-inner-collapseTwo, #inner-collapseOne-saved');
			selectIds.on('show.bs.collapse hidden.bs.collapse', function (e) {
				if (e.target != e.currentTarget) return;
				$(this).prev().find('.fa').toggleClass('fa-plus fa-minus');

			});
			var innerId = $('#aside-inner-collapselvTwo, #aside-inner-collapselvOne');
			innerId.on('show.bs.collapse hidden.bs.collapse', function () {

				$(this).closest('.inner-panel').find('.fa').toggleClass('fa-plus fa-minus');
				$('.lv-panel #aside-inner-headingOne .panel-title').find('.fa').addClass('fa-minus').removeClass('fa-plus');

			});

			var selectIds = $('#collapseOne,#collapseTwo,#collapseThree,#collapseFour');
			selectIds.on('show.bs.collapse hidden.bs.collapse', function () {

				$(this).prev().find('.fa').toggleClass('fa-plus fa-minus');

			});
			var selectClasses = $('.collapseInnerOne', '.collapseInnerTwo');
			selectClasses.on('show.bs.collapse hidden.bs.collapse', function () {

				$(this).prev().find('.fa').toggleClass('fa-plus fa-minus');

			});

			//Wizard Accordian plus minus sign
			var accorIds = $('#billInfo,#shippingInfo,#reviewInfo,#confirmation');
			accorIds.on('show.bs.collapse hidden.bs.collapse', function () {
				$(this).prev().find('.gray-font-color.fa').toggleClass('fa-plus fa-minus');

			});

			//Wizard Accordian plus minus sign
			var accorOneIds = $('#quote-info,#quote-review');
			accorOneIds.on('show.bs.collapse hidden.bs.collapse', function () {
				$(this).prev().find('.gray-font-color.fa').toggleClass('fa-plus fa-minus');

			});
		},
		hoverlay: function () {
			if (Modernizr.touch) {
				// show the close overlay button
				$(".close-overlay").removeClass("hidden");
				// handle the adding of hover class when clicked
				$(".overlay-image").click(function (e) {
					if (!$(this).hasClass("hover")) {
						$(this).addClass("hover");
					}
				});
				// handle the closing of the overlay
				$(".close-overlay").click(function (e) {
					e.preventDefault();
					e.stopPropagation();
					if ($(this).closest(".overlay-image").hasClass("hover")) {
						$(this).closest(".overlay-image").removeClass("hover");
					}
				});
			} else {
				// handle the mouseenter functionality
				$(".overlay-image").mouseenter(function () {
						$(this).addClass("hover");
					})
					// handle the mouseleave functionality
					.mouseleave(function () {
						$(this).removeClass("hover");
					});
			}
		},
		datePicker: function () {
			$('.datepicker').datepicker("destroy");
			$('.date-picker').datepicker({
				orientation: "bottom",
				autoclose: true
			});
		},

		tooltip: function () {
			$('[data-toggle="tooltip"]').tooltip();
		},
		iCheck: function () {
			$('input[type="checkbox"], input[type="radio"]').iCheck({
				checkboxClass: 'icheckbox_square-blue',
				radioClass: 'iradio_square-blue',
				increaseArea: '20%' // optional
			});

			$('#t-and-c').iCheck('login-square');
		},
		niceScroll: function () {
			if ($(window).width() < 991) {
				$("body").getNiceScroll().hide();
			} else {
				// $("[id^=ascrail]").remove();
				$('.table-responsive').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px",
					autohidemode: false

				});
				$('.dropdown-scroll').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});
				$('.notification-list').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});

				$('.cart-details-box').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});
				$('.max-height-table').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});
				$('.ship-responsive').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});
				$('.responsive-orders').niceScroll({
					cursorcolor: "#d4d4d4",
					cursorwidth: "8px"
				});

			}
		},
	};

	window.appSetup = appSetup;

})(window.appSetup || {});